// 1. First, update your routes file with role permissions
// routes/index.js

// Layouts
import PublicLayout from '../../layouts/PublicLayout.vue'
import DashboardLayout from '../../layouts/DashboardLayout.vue'

// Public Views
import Home from '../../views/public/Home.vue'
import About from '../../views/public/About.vue'
import Contact from '../../views/public/Contact.vue'

// Auth Views
import Login from '../../views/auth/Login.vue'
import Register from '../../views/auth/Register.vue'
import ForgotPassword from '../../views/auth/ForgotPassword.vue'
import ResetPassword from '../../views/auth/ResetPassword.vue'

// Dashboard Views
import MyProfile from '../../views/dashboard/MyProfile.vue'
import Forums from '../../views/dashboard/Forums.vue'
import MySurveys from '../../views/dashboard/MySurveys.vue'
import Email from '../../views/dashboard/administration/Email.vue'
import SentMail from '../../views/dashboard/administration/SentMail.vue'
import Authorization from '../../views/dashboard/administration/Authorization.vue'
import WorkingGroups from '../../views/dashboard/administration/WorkingGroups.vue'
import Surveys from '../../views/dashboard/administration/Surveys.vue'
import Reports from '../../views/dashboard/administration/Reports.vue'
import ForumAdmin from '../../views/dashboard/administration/ForumAdmin.vue'
import CMSHome from '../../views/dashboard/cms/Home.vue'
import AboutUs from '../../views/dashboard/cms/AboutUs.vue'
import Networks from '../../views/dashboard/cms/Networks.vue'
import FundingTraining from '../../views/dashboard/cms/FundingTraining.vue'
import News from '../../views/dashboard/cms/News.vue'
import Gallery from '../../views/dashboard/cms/Gallery.vue'
import PublicGallery from "@/views/public/PublicGallery.vue";
import PublicNews from "@/views/public/PublicNews.vue";
import OurFellows from "@/views/public/OurFellows.vue";
import Network from "@/views/public/Network.vue";
import Funding from "@/views/public/Funding.vue";

// SSOComplete
import SsoComplete from '@/views/SsoComplete.vue'

export const routes = [
  // Public Routes
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { layout: PublicLayout, scope: 'public', title: 'Home' }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { layout: PublicLayout, scope: 'public', title: 'About' }
  },
  {
    path: '/our-fellows',
    name: 'Our Fellows',
    component: OurFellows,
    meta: { layout: PublicLayout, scope: 'public', title: 'Our Fellows' }
  },
  {
    path: '/public-news',
    name: 'Stay up to Date',
    component: PublicNews,
    meta: { layout: PublicLayout, scope: 'public', title: 'Stay up to Date' }
  },
  {
    path: '/public-gallery',
    name: 'Video and Photo Gallery',
    component: PublicGallery,
    meta: { layout: PublicLayout, scope: 'public', title: 'Video and Photo Gallery' }
  },
  {
    path: '/network-of-excellence',
    name: 'Network',
    component: Network,
    meta: { layout: PublicLayout, scope: 'public', title: 'Network of Excellence' }
  },
  {
    path: '/funding-and-training',
    name: 'Funding',
    component: Funding,
    meta: { layout: PublicLayout, scope: 'public', title: 'Funding and Training' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: { layout: PublicLayout, scope: 'public', title: 'Contact' }
  },

  // Auth Routes (no layout)
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { scope: 'public', guest: true, title: 'Login' }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { scope: 'public', guest: true, title: 'Register' }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { scope: 'public', guest: true, title: 'Forgot Password' }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { scope: 'public', guest: true, title: 'Reset Password' }
  },

  // Dashboard Routes (Protected) - Available to all authenticated users
  {
    path: '/my-profile',
    name: 'MyProfile',
    component: MyProfile,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'My Profile',
      requiresAuth: true,
      roles: ['Super Admin', 'EDCTP Admin', 'CMS Admin', 'Fellow', 'Testing User']
    }
  },
  {
    path: '/forums',
    name: 'Forums',
    component: Forums,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'Forums',
      requiresAuth: true,
      roles: ['Super Admin', 'EDCTP Admin', 'CMS Admin', 'Fellow', 'Testing User']
    }
  },
  {
    path: '/my-surveys',
    name: 'MySurveys',
    component: MySurveys,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'My Surveys',
      requiresAuth: true,
      roles: ['Super Admin', 'EDCTP Admin', 'CMS Admin', 'Fellow', 'Testing User']
    }
  },

  // Administration Routes - Limited access
  {
    path: '/email',
    name: 'Email',
    component: Email,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'Email',
      requiresAuth: true,
      roles: ['Super Admin']
    }
  },
  {
    path: '/sent-mail',
    name: 'SentMail',
    component: SentMail,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'Sent Mail',
      requiresAuth: true,
      roles: ['Super Admin']
    }
  },
  {
    path: '/authorization',
    name: 'Authorization',
    component: Authorization,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'Authorization',
      requiresAuth: true,
      roles: ['Super Admin', 'EDCTP Admin']
    }
  },
  {
    path: '/working-groups',
    name: 'WorkingGroups',
    component: WorkingGroups,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'Working Groups',
      requiresAuth: true,
      roles: ['Super Admin', 'EDCTP Admin']
    }
  },
  {
    path: '/surveys',
    name: 'Surveys',
    component: Surveys,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'Surveys',
      requiresAuth: true,
      roles: ['Super Admin']
    }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: Reports,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'Reports',
      requiresAuth: true,
      roles: ['Super Admin']
    }
  },
  {
    path: '/forum-admin',
    name: 'ForumAdmin',
    component: ForumAdmin,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'Forum Admin',
      requiresAuth: true,
      roles: ['Super Admin', 'EDCTP Admin']
    }
  },

  // Email response logic

  {
    path: '/working-groups/:groupId/approvals/:approvalId/approve',
    name: 'approve-working-group',
    component: () => import('@/modules/working-groups/pages/ApproveRequest.vue')
  },
  {
    path: '/working-groups/:groupId/approvals/:approvalId/approve',
    component: () => import('@/modules/working-groups/pages/ApproveRequest.vue')
  },
  {
    path: '/working-groups/:groupId/approvals/:approvalId/reject',
    component: () => import('@/modules/working-groups/pages/RejectRequest.vue')
  },
  {
    path: '/working-groups/:groupId/accept-invitation',
    component: () => import('@/modules/working-groups/pages/AcceptInvitation.vue')
  },
  {
    path: '/working-groups/:groupId/decline-invitation',
    component: () => import('@/modules/working-groups/pages/DeclineInvitation.vue')
  },

  // CMS Routes - CMS Admin and Super Admin only
  {
    path: '/cms/home',
    name: 'CMSHome',
    component: CMSHome,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'CMS Home',
      requiresAuth: true,
      roles: ['Super Admin', 'CMS Admin']
    }
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: AboutUs,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'About Us',
      requiresAuth: true,
      roles: ['Super Admin', 'CMS Admin']
    }
  },
  {
    path: '/networks',
    name: 'Networks',
    component: Networks,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'Networks',
      requiresAuth: true,
      roles: ['Super Admin', 'CMS Admin']
    }
  },
  {
    path: '/funding-training',
    name: 'FundingTraining',
    component: FundingTraining,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'Funding & Training',
      requiresAuth: true,
      roles: ['Super Admin', 'CMS Admin']
    }
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'News',
      requiresAuth: true,
      roles: ['Super Admin', 'CMS Admin']
    }
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: Gallery,
    meta: {
      layout: DashboardLayout,
      scope: 'private',
      title: 'Gallery',
      requiresAuth: true,
      roles: ['Super Admin', 'CMS Admin']
    }
  },
  {
    path: '/sso-complete',
    name: 'sso-complete',
    component: SsoComplete,
    meta: {
      scope: 'public',
      guest: true,
      title: 'Signing in'
    }
  },

  // Unauthorized page
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: () => import('../../views/errors/Unauthorized.vue'),
    meta: { layout: PublicLayout, scope: 'public', title: 'Unauthorized' }
  },

  // Catch all 404
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
    meta: { scope: 'public' }
  }
]
